import React, { Component } from 'react';
import { Button, Paper, Grid, Modal } from '@material-ui/core';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

import '../../assets/stylesheets/Setting.css';
import SimilarNames from '../shared/SimilarNames';

class ConfirmAddSimilarModal extends Component {
  render() {
    const { confirmMessage, handleConfirm, itemName, onClose, showModal, similarNames } = this.props;

    return (
      <Modal open={showModal} onClose={onClose}>
        <Paper className="deleteModal">
          <Grid container>
            <Grid item xs={12}>
              <h3>{confirmMessage}</h3>
            </Grid>
            <Grid item xs={12}>
              <h3>{itemName}</h3>
            </Grid>
            <br />
            <SimilarNames similarNames={similarNames} className="warningSimilar ssenseWarning" />
            <br />
            <Grid item xs={6}>
              <Button
                onClick={handleConfirm}
                className="ssenseButton ssensePrimary"
              >
                {i18n.t('confirm')}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={onClose}
                className="ssenseButton ssenseDefault"
              >
                {i18n.t('cancel')}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    );
  }
}

ConfirmAddSimilarModal.propTypes = {
  confirmMessage: PropTypes.string.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  itemName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  similarNames: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ConfirmAddSimilarModal;
